import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import Icon from '@projeccions-pdc/react-icon';
import ContentService from '../../../apiclients/ContentService';
import ShareService from '../../../apiclients/ShareService';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import AttachmentManager from './AttachmentManager';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ContainerService from '../../../apiclients/ContainerService';
import LocalizedStrings from '../../Localization/localization';
import { isElectron } from '../../../helpers';

import Alert from '@material-ui/lab/Alert';

import AppContext from '../../../AppContext';

const styles = (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'justify',
        flexWrap: 'wrap',
    },
    algo: {
        width: '100%',
    },
    paper: {
        padding: 0,
        margin: 5,
        width: '100%',
    },
});

class MailShareDialog extends Component {
    constructor(props) {
        super(props);
        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let myInfo = appContext.getMyInfo();
        // const logoURL = `https://static.${appContext.getConfig().ApiDomain}/platform-config/${platformId}/logo.png`;
        this.state = {
            open: false,
            recipient: '',
            reference: '',
            subject: '',
            body: '',
            footer: `${LocalizedStrings.shareFooter}\n${myInfo.name ? myInfo.name : ''}`,
            attachments: props.attachments,
            logoURL: `https://static.${appContext.getConfig().ApiDomain}/platform-config/${platformId}/logo.png`,
            tab: 0,
            myInfo,
            hasMeetingsOrCollections: false,
        };
        this.notifyId = undefined;
    }

    // static getDerivedStateFromProps(nextProps, prevState) {
    //     if (!this.areArraysEqual(nextProps.attachments, prevState.attachments)) {
    //         return { attachments: cloneDeep(prevState.attachments) };
    //     } else {
    //         return null;
    //     }
    // }
    componentDidMount = () => {
        this.attachmentsHasMeetingsOrCollections().then((hasMeetingsOrCollections) => this.setState({ hasMeetingsOrCollections }));
    };
    componentDidUpdate = (prevProps, prevState) => {
        if (!this.areArraysEqual(this.props.attachments, prevProps.attachments)) {
            this.setState({ attachments: cloneDeep(this.props.attachments) });
            this.attachmentsHasMeetingsOrCollections().then((hasMeetingsOrCollections) => this.setState({ hasMeetingsOrCollections }));
        }
    };

    areArraysEqual = (arrayA, arrayB) => {
        if ((arrayA === undefined && arrayB !== undefined) || (arrayA !== undefined && arrayB === undefined)) return false;
        if (arrayA.length !== arrayB.length) return false;
        for (let a = 0; a < arrayA.length; a++) {
            let found = false;
            for (let b = 0; b < arrayB.length && found === false; b++) {
                if (arrayA[a].identifier === arrayB[b].identifier) {
                    found = true;
                }
            }
            if (found === false) {
                return false;
            }
        }
        return true;
    };

    // https://stackoverflow.com/a/46181
    validateRecipient = () => {
        var re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.state.recipient).toLowerCase());
    };

    handleRecipientChange = (evt) => {
        this.setState({ recipient: evt.target.value });
    };

    handleReferenceChange = (evt) => {
        this.setState({ reference: evt.target.value });
    };

    handleSubjectChange = (evt) => {
        this.setState({ subject: evt.target.value });
    };

    handleContentBodyChange = (event) => {
        this.setState({ body: event.target.value });
    };
    handleContentFooterChange = (event) => {
        this.setState({ footer: event.target.value });
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleShareFile = async () => {
        if (this.state.recipient === '') {
            this.notifyId = this.props.notify('error', LocalizedStrings.errorMailEmpty, this.notifyId);
        } else if (!this.validateRecipient()) {
            this.notifyId = this.props.notify('error', LocalizedStrings.errorMailInvalid, this.notifyId);
        } else if (this.state.subject === '') {
            this.notifyId = this.props.notify('error', LocalizedStrings.errorSubjectEmpty, this.notifyId);
        } else if (this.state.body === '') {
            this.notifyId = this.props.notify('error', LocalizedStrings.errorMessageEmpty, this.notifyId);
        } else {
            this.notifyId = this.props.notify('info', LocalizedStrings.sendingMessage, this.notifyId);

            let attachments = this.state.attachments.map((att) => {
                return {
                    identifier: att.identifier,
                    name: att.name,
                    url: att.url,
                    shareToken: att.shareToken,
                };
            });
            // let appContext = new AppContext();
            // let platformId = appContext.getPlatformId();
            // const logoURL = `https://static.${appContext.getConfig().ApiDomain}/platform-config/${platformId}/logo.png`;

            const html = `<img width="150" style="margin-left:auto;margin-right:0;width:150px;height:auto;margin-bottom:5px;display:block" alt="Logo" src="${
                this.state.logoURL
            }"/><br/>${this.state.body.replace(/\n/gi, '<br/>')}@@ATTACHMENTS@@${this.state.footer.replace(/\n/gi, '<br/>')}`;

            await ShareService.shareFile(
                this.state.recipient,
                this.state.reference ? this.state.reference : '',
                this.state.subject,
                html,
                attachments
            )
                .then((res) => {
                    this.notifyId = this.props.notify('info', LocalizedStrings.messageSent, this.notifyId);
                    this.props.onSuccess();
                })
                .catch((err) => {
                    this.notifyId = this.props.notify('error', LocalizedStrings.errorSending, this.notifyId);
                    this.props.onError(err);
                });

            if (process.env.REACT_APP_IS_CONTAINER === 'true' && isElectron() !== true) {
                try {
                    await ContainerService.shareExternal(this.state.reference ? this.state.reference : '', attachments, true, true);
                } catch (err) {
                    console.log(err.message);
                }
            }
        }
    };

    handleDelete = (index) => () => {
        let newAttachments = cloneDeep(this.state.attachments);
        newAttachments.splice(index, 1);
        this.setState({ attachments: newAttachments });
    };

    onAttachmentsChange = (attachments) => {
        this.setState({ attachments });
    };

    handleTabChange = (event, value) => {
        this.setState({ tab: value });
    };

    handleShareExternalLinks = (evt) => {
        return this.handleShareExternal(evt, true);
    };

    attachmentsHasMixedResources = (attachments) => {
        let hasFiles = false;
        let hasContents = false;
        attachments.forEach((att) => {
            if (att.identifier.indexOf('file~') !== -1) {
                hasFiles = true;
            }
            if (att.identifier.indexOf('content~') !== -1) {
                hasContents = true;
            }
        });

        if (hasFiles === true && hasContents === true) {
            return true;
        }
        return false;
    };

    attachmentsHasMeetingsOrCollections = async () => {
        for (let att of this.props.attachments) {
            if (att.identifier.indexOf('content~') !== -1) {
                const contentId = att.identifier.replace('content~', '');
                const content = await ContentService.getContent(contentId);
                if (content.objectType === 'col' || content.objectType === 'mtg') {
                    return true;
                }
            }
        }
        return false;
    };

    handleShareExternal = async (evt, onlyLinks) => {
        if (process.env.REACT_APP_IS_CONTAINER === 'true' && isElectron() !== true) {
            if (onlyLinks === undefined) {
                onlyLinks = false;
            }

            if (this.state.reference === '') {
                this.notifyId = this.props.notify('error', LocalizedStrings.errorReferenceEmpty, this.notifyId);
                // } else if (this.state.body === '') {
                //     this.notifyId = this.props.notify('error', LocalizedStrings.errorMessageEmpty, this.notifyId);
            } else {
                this.notifyId = this.props.notify('info', LocalizedStrings.sendingMessage, this.notifyId);

                let attachments = this.state.attachments.map((att) => {
                    return {
                        identifier: att.identifier,
                        name: att.name,
                        url: att.url,
                        shareToken: att.shareToken,
                    };
                });

                if (onlyLinks === false && this.attachmentsHasMixedResources(attachments)) {
                    this.notifyMixedId = this.props.notify('info', LocalizedStrings.alertMizedContent, this.notifyMixedId);
                }

                try {
                    // console.log('onlyLinks', onlyLinks)
                    let response = await ContainerService.shareExternal(
                        this.state.reference ? this.state.reference : '',
                        // this.state.body,
                        attachments,
                        onlyLinks
                    );
                    console.log('response', response);
                    // this.notifyId = this.props.notify('info', LocalizedStrings.messageSent, this.notifyId);
                    this.props.onSuccess();
                } catch (err) {
                    console.log(err.message);
                    this.notifyId = this.props.notify('error', LocalizedStrings.errorSending, this.notifyId);
                    this.props.onError(err);
                }
            }
        }
    };

    hasFilesInAttachments = () => {
        let hasFiles = false;
        this.state.attachments.forEach((att) => {
            if (att.identifier.indexOf('file~') !== -1) {
                hasFiles = true;
            }
        });
        return hasFiles;
    };

    render() {
        return (
            <div>
                <DialogTitle>{LocalizedStrings.share}</DialogTitle>
                <DialogContent>
                    {process.env.REACT_APP_IS_CONTAINER === 'true' && isElectron() !== true && (
                        <Tabs value={this.state.tab} onChange={this.handleTabChange}>
                            <Tab label={LocalizedStrings.tabMail} />
                            <Tab label={LocalizedStrings.tabExternal} />
                        </Tabs>
                    )}
                    {this.state.tab === 0 && (
                        <div>
                            <TextField
                                autoFocus
                                margin="dense"
                                label={LocalizedStrings.mailField}
                                type="email"
                                fullWidth
                                value={this.state.recipient}
                                onChange={this.handleRecipientChange}
                            />
                            <TextField
                                margin="dense"
                                label={LocalizedStrings.referenceField}
                                fullWidth
                                value={this.state.reference}
                                onChange={this.handleReferenceChange}
                            />
                            <TextField
                                margin="dense"
                                label={LocalizedStrings.subjectField}
                                fullWidth
                                value={this.state.subject}
                                onChange={this.handleSubjectChange}
                            />
                            {/* <MaterialTextEditor
                                slot="body"
                                placeholder={'Message'}
                                simpleMode={false}
                                content={this.state.body}
                                onChange={this.handleContentBodyChange}
                            /> */}
                            <TextField
                                label={LocalizedStrings.messageField}
                                multiline
                                fullWidth
                                value={this.state.body}
                                onChange={this.handleContentBodyChange}
                                margin="dense"
                            />
                            {/* <TextField
                                label={LocalizedStrings.footerField}
                                multiline
                                fullWidth
                                value={this.state.footer}
                                onChange={this.handleContentFooterChange}
                                margin="dense"
                            /> */}
                        </div>
                    )}
                    {this.state.tab === 1 && (
                        <div>
                            <TextField
                                autoFocus
                                label={LocalizedStrings.referenceField}
                                margin="dense"
                                fullWidth
                                value={this.state.reference}
                                onChange={this.handleReferenceChange}
                            />
                            {/* <TextField
                                label={LocalizedStrings.messageField}
                                multiline
                                margin="dense"
                                fullWidth
                                value={this.state.body}
                                onChange={this.handleContentBodyChange}
                            /> */}
                        </div>
                    )}
                    <br />
                    <div className={this.props.classes.root}>
                        <AttachmentManager
                            notify={this.props.notify}
                            attachments={this.state.attachments}
                            onAttachmentsChange={this.onAttachmentsChange}
                        />
                    </div>
                    {this.state.tab === 0 && (
                        <div>
                            <TextField
                                label={LocalizedStrings.footerField}
                                multiline
                                fullWidth
                                value={this.state.footer}
                                onChange={this.handleContentFooterChange}
                                margin="dense"
                            />
                        </div>
                    )}
                    <br />
                    {/* <DialogContentText>{'** Shared content will be available during 1 year'}</DialogContentText> */}
                    <Accordion>
                        <AccordionSummary expandIcon={<Icon name="md-expand-more" />}>Preview</AccordionSummary>
                        <AccordionDetails>
                            <Paper elevation={0} className={this.props.classes.paper}>
                                <img
                                    style={{
                                        marginLeft: 'auto',
                                        marginRight: 0,
                                        width: '150px',
                                        height: 'auto',
                                        marginBottom: '5px',
                                        display: 'block',
                                    }}
                                    alt="Logo"
                                    src={this.state.logoURL}
                                />
                                <br />
                                <div dangerouslySetInnerHTML={{ __html: this.state.body.replace(/\n/gi, '<br/>') }} />
                                <ul style={{ backgroundColor: '#eee', padding: '2rem', borderRadius: '5px' }}>
                                    {this.state.attachments.map((att) => (
                                        <li key={att.url}>
                                            <a href={att.url}>{att.name}</a>
                                        </li>
                                    ))}
                                </ul>
                                <div dangerouslySetInnerHTML={{ __html: this.state.footer.replace(/\n/gi, '<br/>') }} />
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    {this.state.hasMeetingsOrCollections === true && (
                        <Alert style={{ marginTop: '1rem' }} severity="warning">
                            {LocalizedStrings.shareLinksNotIncluded}
                        </Alert>
                    )}
                </DialogContent>

                <DialogActions>
                    {this.props.autoMode !== true && (
                        <Button color="secondary" onClick={this.props.onClose}>
                            {LocalizedStrings.cancel}
                        </Button>
                    )}
                    <Button color="primary" onClick={this.state.tab === 0 ? this.handleShareFile : this.handleShareExternalLinks}>
                        {this.state.tab === 0 ? LocalizedStrings.share : LocalizedStrings.shareLinks}
                    </Button>
                    {this.state.tab === 1 && this.hasFilesInAttachments() === true && (
                        <Button color="primary" onClick={this.handleShareExternal}>
                            {LocalizedStrings.onlyFiles}
                        </Button>
                    )}
                </DialogActions>
            </div>
        );
    }
}
/*
share links
share only files --> nomes es mostra si hi ha files (si estan barrejats files i contents popup avisa que nomes es compartiran els files)
onlyLinks --> flag a la petició de container
*/

MailShareDialog.propTypes = {
    autoMode: PropTypes.bool,
    attachments: PropTypes.array.isRequired, //[{ name: '', url: '', identifier: '', icon?: '', isImage?:true|false }]

    notify: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,

    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MailShareDialog);
